// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__hbev3","input":"Footer_input__99OmN","input-field":"Footer_input-field__lbvWH","btn":"Footer_btn__UM+Uu"};